import React, { memo } from 'react';
import type { JSX } from 'react';

import { Props } from '@/ui/components/Heading/types';

/**
 * @deprecated Do not use this component. Use the base components at the root of the UI folder instead.
 */
const Heading = ({ className = '', value, text, title, children }: Props) => {
  let Tag: keyof JSX.IntrinsicElements;
  let cssClassName = '';

  switch (value) {
    case 1:
      Tag = 'h1';
      cssClassName += ` text-3xl`;
      break;
    case 2:
      Tag = 'h2';
      cssClassName += ' text-2xl';
      break;
    case 3:
      Tag = 'h3';
      cssClassName += ' text-xl';
      break;
    case 4:
      Tag = 'h4';
      cssClassName += ' text-lg';
      break;
    case 5:
      Tag = 'h5';
      cssClassName += ' text-base';
      break;
    case 6:
      Tag = 'h6';
      cssClassName += ' text-sm';
      break;
    default:
      Tag = 'h1';
      cssClassName += ' text-3xl';
      break;
  }

  return (
    <Tag
      className={`${cssClassName} ${className} light:text-uniform-gray-800 dark:text-uniform-white-base font-bold font-roboto tracking-tightest`}
      title={title}>
      {text} {children}
    </Tag>
  );
};

export default memo(Heading);
